import $ from 'jquery'
import Project from './components/project'
import Home from './components/home'
import About from './components/about'
import gsap from 'gsap'
import stage from './components/stage'
import './jquery.smoothState'

window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.lazyClass = 'lazy';
lazySizesConfig.loadingClass = 'lazyloading';
lazySizesConfig.loadedClass = 'lazyloaded';
lazySizesConfig.loadMode = 1;
lazySizesConfig.preloadAfterLoad = true

import 'lazysizes/plugins/unveilhooks/ls.unveilhooks'
import 'lazysizes/plugins/object-fit/ls.object-fit'
import 'lazysizes/plugins/respimg/ls.respimg'
import 'lazysizes'

class App {

  constructor() {
    this.init()
  }

  init() {

    this.setupSmoothState()
    this.initmodules()

    // $('.main-nav a, .logo').on('click', (e) =>{
    //   e.preventDefault()
    //   var href = $(e.currentTarget).attr('href');
    //   this.smoothState.load(href);
    // })
  }

  setupSmoothState() {
    var failuresLink = {
      prefetch : true,
      forms : false,
      cacheLength: 100,
      scroll: true,
      comunicator: this,
      blacklist : '[href*="/wp-"], a[href$=".jpg"], a[href$=".jpeg"], a[href$=".png"], a[href$=".pdf"]',
      onStart : {
        duration : 900,
        render : this.onTransitionStarted.bind(this)
      },
      onReady : {
        duration : 50,
        render : this.onTransitionReady.bind(this)
      },
      onAfter : this.onTransitionAfter.bind(this)
    };
    this.smoothState = $("#pjax-container").smoothState(failuresLink).data("smoothState");
    //console.log(this.smoothState);
  }

  onTransitionStarted(container) {

    container.addClass('is-exit')
    TweenMax.to(container,1, {autoAlpha: 0})

    // if(this.isproject){
    //   this.animateProjectOut(container)
    // }
    // else{
    //   this.animateHomeOut(container)
    // }

  }

  onTransitionReady(container, newContent) {

    //Page IN

    this.deinit();
    container.html(newContent);
    TweenMax.set(container, {autoAlpha: 0})
    TweenMax.to(container,1, {autoAlpha: 1})

    // if(this.isproject){
    //   this.animateProjectIn(container)
    // }
    // else{
    //   this.animateHomeIn(container)
    // }

  }


  onTransitionAfter(container) {

    //Page Done
    container.removeClass('is-exit')
    this.initmodules();

    // if (window.ga) {
    //   if (ga.create) {
    //     ga("set", {
    //       page : window.location.pathname,
    //       title : document.title
    //     });
    //     ga("send", "pageview");
    //   }
    // }
    if (window.gtag) {
      gtag('config', 'UA-119260693-1', {
        'page_title' : document.title,
        'page_path': window.location.pathname
      });
    }
  }


  deinit(){
    this.home.destroy()
    this.about.destroy()
    this.project.destroy()
  }

  initmodules(){
    this.home = new Home()
    this.about = new About()
    this.project = new Project()
  }

  checkLink(url){
  //  console.log(url)
    //var target = url.replace('http://victoria-bain.a1studio.co', '')
    //this.nextishome = target == '/'

  }


}

module.exports = App
